module.exports = __webpack_public_path__ + "img/details_top02.d0399ccf.png";